/**
 * Created by vladislav on 7/14/2025
 */

const MultiLeagues = function () {};

MultiLeagues.prototype.postRating = function (leagueId, rating, callback = () => {}) {
    if (connector.player.name && connector.player.avatar && !connector.player.avatar.startsWith("#avatars")) {
        ConnectorRestClient.post(`${connector.config.multiApiURL}/leagues/${leagueId}`, {
            id: connector.platform.getUserID(),
            name: connector.player.name,
            avatar: connector.player.avatar,
            rating
        }, () => {
            callback(true);
        }, () => {
            callback(false);
        });
    }
};

MultiLeagues.prototype.get = function (leagueIds, callback = () => {}) {
    const path = `${connector.config.multiApiURL}/leagues?ids=${leagueIds}`;

    ConnectorRestClient.get(path, {}, callback, () => {
        callback();
    });
};